(function ($) {
  function WheelOfFortune(element, options) {
    (this.$el = $(element)), (this.options = options), this._generate();
  }
  (WheelOfFortune.prototype = {
    _generate: function () {
      var self = this,
        canvas = (self.canvas = document.createElement("canvas")),
        context = (self.ctx = canvas.getContext("2d"));
      self.$el.children().remove(),
        (self.$wheel = $(canvas).css({
          position: "absolute",
          width: "100%",
          height: "100%",
          "z-index": 100,
        })),
        (self.$pointer = $("<div></div>").css({ position: "absolute" })),
        self.$el.append(self.$wheel),
        self.$el.append(self.$pointer),
        self._setRequestAnimFrame(),
        self._init(),
        self._drawTriangles();
        
    },
    _drawTriangles: function () {
      var self = this;
      self._clear();
      var context = self.ctx,
        options = self.options,
        radius = self.radius,
        centerX = 0,
        centerY = 0,
        count = options.elements.length,
        startAngle = 0,
        stepAngle = (2 * Math.PI) / count,
        endAngle = 0,
        colors = options.colors,
        colorIndex = 0;
      for (i = 0; i < count; i++)
        (endAngle = startAngle + stepAngle),
          self._drawTriangle(
            centerX,
            centerY,
            radius,
            startAngle,
            endAngle,
            colors[colorIndex]
          ),
          (startAngle = endAngle),
          (colorIndex = colorIndex == colors.length - 1 ? 0 : colorIndex + 1);
      self._drawElements();
    },
    _drawTriangle: function (
      centerX,
      centerY,
      radius,
      startAngle,
      endAngle,
      color
    ) {
      var context = this.ctx;
      context.beginPath(),
        context.moveTo(centerX, centerY),
        context.arc(centerX, centerY, radius, startAngle, endAngle, !1),
        context.lineTo(centerX, centerY),
        context.closePath(),
        (context.fillStyle = color),
        context.fill();
    },
    _drawElements: function () {
      var self = this,
        context = self.ctx,
        options = self.options,
        elements = options.elements,
        count = elements.length;
      context.save();
      var innerAngle = (2 * Math.PI) / count,
        angle = (Math.PI - innerAngle) / 2,
        h = Math.sin(angle) * (self.radius - options.fontSize),
        x = Math.sin(angle) * h,
        y = Math.cos(angle) * h;
      for (i = 0; i < count; i++)
        context.translate(x, y),
          context.rotate(-angle),
          (context.textAlign = "center"),
          (context.fillStyle = options.fontColor),
          (context.font = options.fontSize + "px " + options.fontFamily),
          context.fillText(elements[i], 0, options.fontSize / 2),
          context.rotate(angle),
          context.translate(-x, -y),
          context.rotate(innerAngle);
      context.restore();
    },
    _init: function () {
      var self = this,
        context = self.ctx,
        canvas = self.canvas,
        options = self.options,
        count = options.elements.length,
        stepAngle = (2 * Math.PI) / count;
      (self.stopAtIndex =
        options.stopAtIndex || Math.floor(Math.random() * (count + 1))),
        (self.distanceTraveled = 0),
        (self.pathLength =
          options.numberOfRotations * 2 * Math.PI -
          stepAngle / 2 -
          stepAngle * self.stopAtIndex),
        (self.currentSpeed = self.rotationSpeed =
          (options.rotationSpeed * Math.PI) / 180),
        (self.minimalSpeed = (options.minimalSpeed * Math.PI) / 180);
      var innerWidth = self.$wheel.innerWidth(),
        innerHeight = self.$wheel.innerHeight();
      self.radius = innerWidth < innerHeight ? innerWidth / 2 : innerHeight / 2;
      var devicePixelRatio = window.devicePixelRatio || 1;
      canvas.setAttribute("width", innerWidth * devicePixelRatio),
        canvas.setAttribute("height", innerHeight * devicePixelRatio),
        context.translate(canvas.width / 2, canvas.height / 2),
        context.scale(devicePixelRatio, devicePixelRatio),
        self.$pointer.css({
            width: "0",
            height: "0",
            "border-top": options.pointerHeight / 2 + "px solid transparent",
            "border-bottom": options.pointerHeight / 2 + "px solid transparent",
            "border-right": options.pointerWidth + "px solid " + options.pointerColor,
            position: "absolute",
            left: innerWidth / 2 + self.radius - options.pointerWheelOverlap + "px",
            top: (innerHeight - options.pointerHeight) / 2 + "px",
            "z-index": 200
          });
        self._clear();
    },
    _clear: function () {
      var self = this,
        context = self.ctx,
        canvas = self.canvas;
      context.clearRect(
        -canvas.width,
        -canvas.height,
        canvas.width * 2,
        canvas.height * 2
      );
    },
    _setRequestAnimFrame: function () {
      var self = this;
      self.requestAnimFrame = (function (callback) {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimationFrame ||
          function (callback2) {
            window.setTimeout(callback2, 1e3 / 60);
          }
        );
      })();
    },
    _rotate: function (previousTime, previousAngle) {
      var self = this,
        canvas = self.canvas,
        context = self.ctx,
        options = self.options,
        rotationSpeed = self.currentSpeed;
      if (!options.constantSpeed && self.currentSpeed > self.minimalSpeed) {
        var treshold = options.brakeTreshold,
          traveledPercentage = self.distanceTraveled / self.pathLength;
        rotationSpeed = self.currentSpeed =
          traveledPercentage < treshold
            ? self.rotationSpeed
            : (1 - (traveledPercentage - treshold) * (1 / (1 - treshold))) *
              self.rotationSpeed;
      }
      var currentTime = new Date().getTime(),
        timeDelta = currentTime - previousTime,
        rotationAngle = (rotationSpeed * timeDelta) / 1e3;
      if (
        ((self.distanceTraveled += rotationAngle),
        self.distanceTraveled >= self.pathLength)
      ) {
        (rotationAngle -= self.distanceTraveled - self.pathLength),
          context.rotate(rotationAngle),
          self._drawTriangles(),
          options.onFinished.call(self, options.elements[self.stopAtIndex]);
        return;
      }
      context.rotate(rotationAngle),
        self._drawTriangles(),
        self.requestAnimFrame.call(window, function () {
          self._rotate(currentTime, rotationAngle);
        });
    },
    spin: function () {
      var self = this,
        startTime = new Date().getTime();
      self._rotate(startTime, 0);
    },
    destroy: function () {
      var self = this;
      self.$el.children().remove(), self.$el.removeData("wheelOfFortune");
    },
    reset: function () {
      var self = this,
        wheelOfFortune;
      self._generate();
    },
  }),
    ($.fn.wheelOfFortune = function (options) {
      function get() {
        var wheelOfFortune = $.data(this, "wheelOfFortune");
        return (
          wheelOfFortune ||
            ((wheelOfFortune = new WheelOfFortune(this, $.extend({}, options))),
            $.data(this, "wheelOfFortune", wheelOfFortune)),
          wheelOfFortune
        );
      }
      var runCommand = function () {
        var wheelOfFortune = $.data(this, "wheelOfFortune");
        wheelOfFortune[options]();
      };
      if (typeof options == "string") {
        this.each(runCommand);
        return;
      }
      return (
        (options = options || {}),
        (options = $.extend({}, $.fn.wheelOfFortune.defaults, options)),
        this.each(get)
      );
    }),
    ($.fn.wheelOfFortune.defaults = {
      elements: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      stopAtIndex: null,
      colors: ["#3A8E98", "#FFFFFF"],
      rotationSpeed: 360,
      numberOfRotations: 3,
      constantSpeed: !1,
      brakeTreshold: 0.5,
      minimalSpeed: 10,
      fontSize: 60,
      fontFamily: "Arial",
      fontColor: "#000",
      pointerColor: "#000",
      pointerWidth: 60,
      pointerHeight: 20,
      pointerWheelOverlap: 20,
      onFinished: function (selectedValue) {},
    });
})(jQuery);
//# sourceMappingURL=/cdn/shop/t/2/assets/wheel-of-fortune.js.map?v=160763543416587982301610535791
